import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    checkifbatchused (id) {
        return Api().get('productsales/checkifbatchused/'+id)
    },
    getprevsales (party) {
        return Api().get('productsales/getprevsales/'+party)
    },


    //GMW
    checkifbatchusedgmw (id) {
        return GmwApi().get('productsales/checkifbatchused/'+id)
    },
    getprevsalesgmw (party) {
        return GmwApi().get('productsales/getprevsales/'+party)
    },
}